import { render, staticRenderFns } from "./MemberAdmin.vue?vue&type=template&id=25bfb89b&scoped=true&"
import script from "./MemberAdmin.vue?vue&type=script&lang=js&"
export * from "./MemberAdmin.vue?vue&type=script&lang=js&"
import style0 from "./MemberAdmin.vue?vue&type=style&index=0&id=25bfb89b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bfb89b",
  null
  
)

export default component.exports